export var injectScript = function (src) {
    var d = document;
    var aws = d.createElement('script');
    aws.type = 'text/javascript';
    aws.async = true;
    aws.src = src;
    var s = d.getElementsByTagName('script')[0];
    s && s.parentNode && s.parentNode.insertBefore(aws, s);
};
//# sourceMappingURL=index.js.map